// src/components/Header.js
import { useEffect, useRef, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../hooks/useAuth";
import useModal from "../hooks/useModal";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const Header = ({ nologo = false, noconsole = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();
  const { openModal } = useModal();

  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const tokenString = localStorage.getItem("token");
  const user = tokenString
    ? JSON.parse(window.atob(tokenString.split(".")[1]))
    : null;

  const { isBusiness } = useAuth();

  const handleOpenConsole = () => {
    openModal("console", { token });
  };

  const renderMenuButton = (label, onClick, roundBottom) => (
    <button
      onClick={onClick}
      className={`block w-full text-left px-3 py-1.5 hover:bg-sunset hover:text-delft-blue transition-colors duration-200 ${
        roundBottom ? "rounded-b-md" : ""
      }`}
    >
      {label}
    </button>
  );

  return (
    <header className="bg-delft-blue sticky top-0 z-10 flex justify-between items-center px-3 text-md sm:text-xl font-bold shadow-sm">
      {/* Left: Logo */}
      <div className={`flex items-center ${nologo ? "invisible" : ""}`}>
        <button
          className="flex items-center space-x-1 text-sunset"
          onClick={() => navigate("/")}
        >
          <span>loghook.net</span>
        </button>
      </div>

      {/* Right: Burger Menu */}
      <div className="relative" ref={menuRef}>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="text-eggshell focus:outline-none my-1 px-2 rounded-md hover:bg-sunset hover:text-delft-blue transition-colors duration-200"
        >
          <FontAwesomeIcon icon={faBars} className="text-xl " />
        </button>
        {menuOpen && (
          <div className="absolute right-0 mt-1 w-40 bg-delft-blue  rounded-lg shadow-lg text-sm text-eggshell z-20 shadow-lg">
            {user ? (
              <>
                <div
                  className="px-4 py-2 border-b border-eggshell text-xs rounded-t-lg hover:bg-sunset hover:text-delft-blue hover:cursor-pointer"
                  onClick={() => navigate("/profile")}
                >
                  Logged in as <span className="font-bold">{user.email}</span>
                </div>
                {renderMenuButton("Dashboards", () => navigate("/dashboards"))}
                {isBusiness &&
                  renderMenuButton("Team", () => navigate("/team"))}
                {renderMenuButton("Logout", () => {
                  localStorage.removeItem("token");
                  navigate("/");
                })}
              </>
            ) : (
              <>
                {renderMenuButton("Log In", () => navigate("/login"))}
                {renderMenuButton("Register", () => navigate("/register"))}
              </>
            )}
            {!noconsole &&
              renderMenuButton("Docs & Console", handleOpenConsole, true)}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
